import {SearchDialog} from '@appscience/popups'
import {SearchIcon} from '@heroicons/react/outline'
import {useHotkeys} from '@mantine/hooks'
import {TableNode} from '@table-library/react-table-library'
import {compose, isEmpty} from 'ramda'
import {useState} from 'react'
import {TransparentActionIcon} from '../consumables/transparent-action-icon'
import {cleanObject, isNullable, joinStrings} from '@appscience/utils'
import {useDataTableContext, useDataTableRefsContext} from '../../context'
import {DataTableActionsSectionProps} from './model'
import {DataTableMoreButton} from './more-button/more-button'

export function DataTableActionsSection<ColumnID extends string, ITEM extends TableNode>({
  actionsSection,
  searchData,
  ...moreButtonProps
}: DataTableActionsSectionProps<ColumnID, ITEM>) {
  const [showSearch, setShowSearch] = useState(false)
  const showMoreButton = !compose(isEmpty, cleanObject)(moreButtonProps)
  const {setSearchValue} = useDataTableContext()
  const {pagination: { onSetPage }} = useDataTableRefsContext().callbacksRef.current
  const openSearchDialog = () => setShowSearch(true)
  useHotkeys([
    ['ctrl+k', openSearchDialog],
  ])

  return (
    <div className={joinStrings('flex mb-3', actionsSection?.className)}>
      {!!searchData && <SearchDialog
        show={showSearch}
        onSearch={value => {
          setSearchValue(value.trim())
          onSetPage(0)
        }}
        onClose={() => {
          setShowSearch(false)
          setSearchValue('')
        }}
        position={{
          top: 55,
          right: `calc(50% - 200px)`,
        }}
      />}
      {!!actionsSection && actionsSection.subsection}
      {!!searchData && (
        <TransparentActionIcon onClick={openSearchDialog}>
          <SearchIcon className='w-4 h-4' />
        </TransparentActionIcon>
      )}
      {showMoreButton && <DataTableMoreButton {...moreButtonProps} />}
    </div>
  )
}

export function getDataTableActionsSectionProps<ColumnID extends string, ITEM extends TableNode>({
  exportCsv,
  searchData,
  actionsSection,
  manageColumns,
  extraActions,
}: DataTableActionsSectionProps<ColumnID, ITEM>): null|DataTableActionsSectionProps<ColumnID, ITEM> {
  if (isNullable(exportCsv) && isNullable(searchData) && isNullable(actionsSection) && isNullable(manageColumns) && isNullable(extraActions)) {
    return null
  }

  return {
    exportCsv,
    actionsSection,
    searchData,
    manageColumns,
    extraActions,
  }
}